import { Close } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Grid, IconButton, Tooltip, Link } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import {
  addCreditsToWorkspaceUser,
  getDefinedCreditsForWorkspaceUsers,
  getMassMailingCredsPerDay,
  getTotalMailingCreditsAllotted,
  IAddCreditsPayload,
  resetToDefaultMailingsCredits,
} from 'wisestep-api';
import { WsTypography, WsTypoVariants, WsButton, WsInputNumber } from 'wisestep-base';

import RecruiterSuggestions from '../../../../components/filters/components/RecruiterSuggestions';
import { Credits } from '../../utils/vendorsHelper';

import ShareCreditTable from './ShareCreditTable';

interface ShareCreditPros {
  closeDilog: () => void;
}

const SharedCredits = ({ closeDilog }: ShareCreditPros) => {
  const [isShared, setIsShared] = useState<boolean>(false);
  const [credits, setCredits] = useState<Credits>({ balance: 0, used: 0 });
  const [userData, setUsersData] = useState({});
  const [allotedCredits, setAllotedCredits] = useState<number>(0);
  const [defaultValue, setDefaultValue] = useState<string>();
  const methods = useForm();
  const GetMassMailingCreds = async () => {
    const response = await getMassMailingCredsPerDay();
    setCredits({ balance: response.data[0]['balance'], used: response.data[0]['used'] });
  };
  const GetDefinedCreditsForWorkspaceUsers = async () => {
    const workspaceUsers = await getDefinedCreditsForWorkspaceUsers();
    workspaceUsers.data && setUsersData(workspaceUsers.data);
  };
  const GetTotalMailingCreditsAllotted = async () => {
    const allotedRes = await getTotalMailingCreditsAllotted();
    setAllotedCredits(allotedRes.data['totalAllottedInWorkspace']);
  };
  useEffect(() => {
    const fetchCredits = async () => {
      GetMassMailingCreds();
      GetDefinedCreditsForWorkspaceUsers();
      GetTotalMailingCreditsAllotted();
    };
    fetchCredits();
  }, []);

  const resetTODefault = async () => {
    await resetToDefaultMailingsCredits();
    GetMassMailingCreds();
    GetDefinedCreditsForWorkspaceUsers();
    GetTotalMailingCreditsAllotted();
  };

  const shareCredits = async () => {
    if (methods.getValues('recruiters') == undefined)
      methods.setValue('recruiters', [defaultValue]);
    const req: IAddCreditsPayload = {
      email: methods.getValues('recruiters')[0],
      creditsPerDay: methods.getValues('credits'),
      selectedSuggestion: [],
    };
    await addCreditsToWorkspaceUser(req);
    GetMassMailingCreds();
    GetDefinedCreditsForWorkspaceUsers();
    GetTotalMailingCreditsAllotted();
    setIsShared(false);
    methods.setValue('recruiters', '');
    methods.setValue('credits', 0);
  };

  return (
    <FormProvider {...methods}>
      <Box p={2}>
        <Grid pb={1} item container xs={12} justifyContent="space-between" alignItems="center">
          <WsTypography variant={WsTypoVariants.TITLE} bold>
            Share Mailing Credits with Workspace Users
          </WsTypography>
          <IconButton onClick={closeDilog}>
            <Close />
          </IconButton>
        </Grid>
        <Grid item display="flex" flexDirection="row" columnGap={0.5}>
          <WsTypography variant={WsTypoVariants.BODY1} bold>
            NOTE--
          </WsTypography>
          <WsTypography variant={WsTypoVariants.BODY1}>
            If any un-allocated credits left without sharing then you cannot use those credits like
            you use in default workspace credits usage flow. Either allot all remaining credits to
            users or switch to default workspace credits usage flow.
          </WsTypography>
        </Grid>
        <Box pt={2}>
          <WsTypography variant={WsTypoVariants.BODY1}>
            Click
            <Link onClick={resetTODefault}> Reset to deafult </Link>
            to switch back to default credits usage flow.
          </WsTypography>
        </Box>
        <Grid display="flex" justifyContent="space-between" alignItems="center" pt={2}>
          <WsTypography variant={WsTypoVariants.BODY1}>
            Credits Un-allotted/Total
            <Tooltip
              title="Credit Un-allocated against to the total credits defined for workspace"
              placement="top"
            >
              <IconButton>
                <InfoIcon />
              </IconButton>
            </Tooltip>
            :
            <WsButton variant="text">
              {`${credits?.balance - allotedCredits}/${credits?.balance + credits.used}`}
            </WsButton>
          </WsTypography>
          <WsButton onClick={() => setIsShared(true)} variant="contained" size="small">
            Add Credits to Workspace User
          </WsButton>
        </Grid>
        {isShared ? (
          <Grid fontSize={12} spacing={1} container alignItems="center" py={1}>
            <Grid item xs={6}>
              <RecruiterSuggestions
                name="recruiters"
                defaultValue={[defaultValue ?? '']}
                multiple={false}
              />
            </Grid>
            <Grid item xs={2}>
              <WsInputNumber name="credits" />
            </Grid>
            <Grid item xs={4} spacing={1} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <IconButton color="info" onClick={() => setIsShared(false)}>
                <CloseIcon />
              </IconButton>
              <IconButton color="info" onClick={shareCredits}>
                <SaveIcon />
              </IconButton>
            </Grid>
          </Grid>
        ) : (
          <></>
        )}
      </Box>
      {Object.keys(userData).length > 0 && (
        <Grid item xs={12} container px={2}>
          <ShareCreditTable
            data={userData ?? {}}
            onDelete={() => {
              GetMassMailingCreds();
              GetDefinedCreditsForWorkspaceUsers();
              GetTotalMailingCreditsAllotted();
            }}
            onEdit={(id: string) => {
              setIsShared(true);
              setDefaultValue(id);
            }}
          />
        </Grid>
      )}
    </FormProvider>
  );
};
export default SharedCredits;
